module.exports = __webpack_public_path__ + "img/Skirt-Front-B3-Da-Fb-Gd-Hc-Ia.fc7c64d2.png";